import React, { useEffect, useState } from "react";
import {
  Card, Table, Button,Progress, Modal, Form, Input,Space, InputNumber,DatePicker, Select, Upload,message, Row, Col, Popconfirm, Tooltip, Radio
} from "antd";
import api from '../api/axios';
import moment from "moment";
import { EditOutlined, DeleteOutlined,UploadOutlined, DownloadOutlined ,MergeOutlined} from "@ant-design/icons";
import Merge_PDF from './Merge_PDF';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;

export default function PurchaseInvoice() {
  const navigate = useNavigate();

  const [invoices, setInvoices] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [editingInvoice, setEditingInvoice] = useState(null);

  //for customers
    const [customers, setCustomers] = useState([]);

  // For view Invoice popup
  const [viewInvoice, setViewInvoice] = useState(null);
  const [viewItems, setViewItems] = useState([]);

  // Loading and filter states
  const [loading, setLoading] = useState(false);
  const [dateFilter, setDateFilter] = useState("");
  const [supplierFilter, setSupplierFilter] = useState([]);
  const [poNumberFilter, setPONumberFilter] = useState([]);
  const [statusFilter, setStatusFilter] = useState([]);  // now an array
  const [invoiceNumberFilter, setInvoiceNumberFilter] = useState([]);

    const [invoiceNumber, setInvoiceNumber] = useState('');  // initially empty
    const [isDuplicate, setIsDuplicate] = useState(null);   // null means no check yet
    const [supplierId, setSupplierId] = useState('');

    const [debounceTimeout, setDebounceTimeout] = useState(null);

    //const [userEditedTaxIndexes, setUserEditedTaxIndexes] = useState(new Set());

    // for file upload progress
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState({});

  //for file upload
    const [fileList, setFileList] = useState(
        editingInvoice?.InvoiceFiles?.map((url, idx) => ({
            uid: `file-${idx}`,
            name: url.split('/').pop(),
            status: 'done',
            url,
        })) || []
    );
  //for customers
        useEffect(() => {
            // Fetch customer data when component mounts
            fetch('/customers')          // Adjust endpoint to your API route!
                .then(res => res.json())
                .then(data => setCustomers(data))
                .catch(err => {
                    console.error("Failed to fetch customers", err);
                    setCustomers([]);
                });
        }, []);

// radio button for IGST or CGST/SGST
    const [taxType, setTaxType] = useState('IGST'); // or from props/context
    const [sacCodes, setSacCodes] = useState([]);
// Load sacCodes on component mount (useEffect)
    useEffect(() => {
        api.get('/saccode').then(res => setSacCodes(res.data));
    }, []);

// Handler to add files to list
    const handleBeforeUpload = (file) => {
        setFileList(prevList => [...prevList, file]);
        return false; // Prevent automatic upload by Upload component
    };

// Handler to remove a file selected for upload
    const handleRemove = (file) => {
        setFileList(prevList => prevList.filter(item => item.uid !== file.uid));
    };

    // Helper for required asterisk in item table header
  const requiredHeader = (label) => (
      <span style={{ fontWeight: 'bold' }}>
      {label}
        <span style={{ color: 'red', marginLeft: 2 }}>*</span>
    </span>
  );

  // Fetch all data
  const fetchData = () => {
    setLoading(true);
    Promise.all([
      api.get("/invoices/purchase"),
      api.get("/suppliers"),
      api.get("/pomaster")
    ])
        .then(([invoiceRes, supplierRes, poRes]) => {
          setInvoices(invoiceRes.data);
          setFilteredInvoices(invoiceRes.data);
          setSuppliers(supplierRes.data);
        })
        .catch(e => message.error("Failed to load invoices, suppliers, or PO list"))
        .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Filtering logic
  useEffect(() => {
    let data = [...invoices];

    if (supplierFilter.length)
      data = data.filter(inv => supplierFilter.includes(inv.SupplierID));
      if (invoiceNumberFilter.length) {
          data = data.filter(inv => invoiceNumberFilter.includes(inv.InvoiceNumber));
      }
    if (dateFilter) {
      const m = dateFilter.match(/^([<>]=?|=)\s*(\d{4}-\d{2}-\d{2})$/);
      if (m) {
        const op = m[1];
        const dateStr = m[2];
        if (op === ">") {
          data = data.filter(inv => moment(inv.Date).isAfter(dateStr, "day"));
        } else if (op === "<") {
          data = data.filter(inv => moment(inv.Date).isBefore(dateStr, "day"));
        } else if (op === ">=") {
          data = data.filter(inv => moment(inv.Date).isSameOrAfter(dateStr, "day"));
        } else if (op === "<=") {
          data = data.filter(inv => moment(inv.Date).isSameOrBefore(dateStr, "day"));
        } else if (op === "=") {
          data = data.filter(inv => moment(inv.Date).isSame(dateStr, "day"));
        }
      }
    }
    if (poNumberFilter.length)
      data = data.filter(inv => poNumberFilter.includes(inv.PO_Number));
    // Status: Use filter if explicitly set, else hide "Full"
    if (statusFilter.length)
      data = data.filter(inv => statusFilter.includes(inv.Status));
    //else
      //data = data.filter(inv => inv.Status !== "Full");

    setFilteredInvoices(data);
  }, [supplierFilter, dateFilter, poNumberFilter, statusFilter, invoiceNumberFilter,invoices]);

  // pre-fill fileList for Edit mode
    useEffect(() => {
        if (editingInvoice?.InvoiceID && editingInvoice.InvoiceFile) {
            try {
                const files = JSON.parse(editingInvoice.InvoiceFile || '[]');

                const fileListData = files.map((filePath, index) => ({
                    uid: `existing-${index}`,        // ✅ Unique ID
                    name: filePath.split('/').pop(), // ✅ Filename only
                    status: 'done',                  // ✅ Mark as uploaded
                    url: `${filePath}`,   // ✅ Full preview URL
                    response: { path: filePath }     // ✅ Store original path for backend
                }));

                setFileList(fileListData);
                console.log(`✅ Edit: Loaded ${files.length} existing files`);
            } catch (error) {
                // Fallback for old single-file format
                console.log('Old single file format detected');
                setFileList([{
                    uid: 'existing-0',
                    name: editingInvoice.InvoiceFile.split('/').pop(),
                    status: 'done',
                    url: `${editingInvoice.InvoiceFile}`,
                    response: { path: editingInvoice.InvoiceFile }
                }]);
            }
        } else {
            setFileList([]);  // Clear for new invoice
        }
    }, [editingInvoice]);  // Runs when editingInvoice changes

    // Helper: get supplier name by ID
    const getSupplierName = (id) => {
        const supplier = suppliers.find(s => s.SupplierID === id);
        return supplier ? supplier.SupplierName : id;
    };

    const supplierID = form.getFieldValue('SupplierID');
    const supplierName = getSupplierName(supplierID);


  const handleViewInvoice = (invoice) => {
    setViewInvoice(invoice);
    api.get(`/invoices/purchase/${invoice.InvoiceID}/items`).then(res => {
      setViewItems(res.data);
    });
  };


  // Add or Edit invoice
    const onFinish = async (values) => {
        // ✅ Validate files first
        //if (fileList.length === 0 && !editingInvoice?.InvoiceFile) {
        //    message.warning('Please upload at least one file');
        //    return;
        //}

        setUploading(true);

        fileList.forEach(f => {
            console.log(f.name, f.originFileObj ? "Has originFileObj" : "No originFileObj");
        });

        // 1. Prepare FormData for multipart request
        const formData = new FormData();

        // Append all other form fields except 'Items' and files
        Object.entries(values).forEach(([key, value]) => {
            if (key !== 'Items' && key !== 'invoiceFile') {
                if (value && typeof value.format === 'function') {
                    formData.append(key, value.format('YYYY-MM-DD'));
                } else {
                    formData.append(key, value ?? '');
                }
            }
        });

        // Append 'Items' as JSON string explicitly
        formData.append('Items', JSON.stringify(values.items));

        // ✅ Initialize progress for each new file
        const newFiles = [];
        fileList.forEach(file => {
            if (file.originFileObj) {
                formData.append('invoiceFiles', file.originFileObj);
                newFiles.push(file.uid);
                setUploadProgress(prev => ({ ...prev, [file.uid]: 0 }));  // Start at 0%
            } else {
                formData.append('invoiceFiles', file);
            }
        });

        // Handle case: if no new file uploaded & editingInvoice has existing file path
        if (
            editingInvoice &&
            editingInvoice.InvoiceFile &&
            !fileList.some(file => file.originFileObj)
        ) {
            formData.append('oldInvoiceFile', editingInvoice.InvoiceFile);
        }

        // 2. API call with PROGRESS TRACKING
        const url = editingInvoice
            ? `/invoices/purchase/${editingInvoice.InvoiceID}`
            : "/invoices/purchase";

        const method = editingInvoice ? 'put' : 'post';

        try {
            const response = await api({
                method,
                url,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                timeout: 60000,  // 60s for large files
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.total) {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        console.log(`Upload progress: ${percentCompleted}%`);

                        // Update overall progress
                        setUploadProgress(prev => ({
                            ...prev,
                            overall: percentCompleted
                        }));
                    }
                }
            });

            message.success(editingInvoice
                ? "Invoice updated!"
                : `Purchase invoice added! Invoice Number: ${response.data.InvoiceNumber}`);

            setVisible(false);
            setEditingInvoice(null);
            form.resetFields();
            fetchData();
            setFileList([]);
            setUploading(false);
            setUploadProgress({});

        } catch (error) {
            console.error('Upload error:', error);

            // ✅ Specific 413 handling
            if (error.response?.status === 413) {
                message.error('File too large! Maximum 10MB per file. Please upload smaller files.');
            } else {
                message.error(`Error saving invoice: ${error.response?.data?.error || error.message}`);
            }

            setUploading(false);
        }
    };


    // Edit handler
  const handleEditInvoice = (invoice) => {

    setEditingInvoice(invoice);
    setVisible(true);

    // Prefill the Upload fileList with the existing file, if any
    if (invoice.InvoiceFile) {
      setFileList([
        {
          uid: "-1",
          name: invoice.InvoiceFile.split("/").pop(),
          status: "done",
          url: invoice.InvoiceFile,
        }
      ]);
    } else {
      setFileList([]); // clear if none
    }

    // Fetch items for this invoice
    api.get(`/invoices/purchase/${invoice.InvoiceID}/items`).then(res => {
      // Find supplier name using SupplierID from suppliers array
      const supplier = suppliers.find((s) => s.SupplierID === invoice.SupplierID);
      const supplierName = supplier ? supplier.SupplierName : "";
      //alert(`SupplierName: ${supplierName}`);
      form.setFieldsValue({
        ...invoice,
        Date: invoice.Date ? moment(invoice.Date) : null,
        PO_Date: invoice.PO_Date ? moment(invoice.PO_Date) : null,
        items: res.data.length ? res.data : [{}],
        SupplierID: invoice.SupplierID,
        SupplierName: supplierName,
      });


    });

  };


  // Delete handler
  const handleDeleteInvoice = (invoiceId) => {
    api.delete(`/invoices/purchase/${invoiceId}`)
        .then(() => {
          message.success("Invoice deleted!");
          // Refresh list if needed:
          fetchData && fetchData();
          // CLEAR editingInvoice and file upload state:
          setEditingInvoice(null);    // <-- Add this line
          setFileList([]);            // (Optional: clear any file upload UI)
        })
        .catch(e => {
          message.error("Failed to delete invoice: " + (e.response?.data?.error || e.message));
        });
  };

// function to check if duplicate of invoicenumber + SupplierName
    const checkDuplicate = (supplierName, invoiceNum) => {
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }

        const timeout = setTimeout(async () => {
            if (!supplierName || !invoiceNum) {
                setIsDuplicate(false);
                return;
            }
            try {
                const res = await api.get(`/invoices/purchaseinvoice/check-duplicate?supplierName=${supplierName}&invoiceNumber=${invoiceNum}`);
                setIsDuplicate(res.data.count > 0);
            } catch {
                setIsDuplicate(false);
            }
        }, 300); // wait 300ms after last call

        setDebounceTimeout(timeout);
    };

    const onInvoiceNumberChange = (e) => {
        const val = e.target.value;
        setInvoiceNumber(val);
        const supplierName = form.getFieldValue('SupplierName');
        if (val) checkDuplicate(supplierName, val);
        else setIsDuplicate(false);
    };


    const onRateOrQuantityChange = (index, field, value) => {
        const items = form.getFieldValue('items') || [];
        const currentItem = items[index] || {};

        const newItem = { ...currentItem, [field]: value };

        const rate = Number(newItem.Rate) || 0;
        const quantity = Number(newItem.Quantity) || 0;
        const basicAmount = rate * quantity;

        // Calculate TaxAmount ignoring manual edits
        const totalTaxRate = (Number(newItem.CGST) || 0) + (Number(newItem.SGST) || 0) + (Number(newItem.IGST) || 0);
        const calculatedTaxAmount = (basicAmount * totalTaxRate) / 100;

        newItem.TaxAmount = calculatedTaxAmount;
        newItem.Total = basicAmount + calculatedTaxAmount;
        // Clear manual edit mark (ignore manual tax when rate/qty changed)
        newItem._userEditedTaxAmount = false;

        items[index] = newItem;

        const invoiceTotal = items.reduce((sum, item) => sum + (Number(item.Total) || 0), 0);

        form.setFieldsValue({ items, InvoiceTotal: invoiceTotal });
    };

    // Table columns with sorting and filters
  const columns = [
    {
      title: "Invoice Number",
      dataIndex: "InvoiceNumber",
      sorter: (a, b) => (a.InvoiceNumber || "").localeCompare(b.InvoiceNumber || "")
    },
    {
      title: "Supplier",
      dataIndex: "SupplierID",
      render: (id) => getSupplierName(id),
      sorter: (a, b) => getSupplierName(a.SupplierID).localeCompare(getSupplierName(b.SupplierID))
    },
    {
      title: "Date",
      dataIndex: "Date",
      sorter: (a, b) => new Date(a.Date) - new Date(b.Date)
    },
    {
      title: "Total Amount",
      dataIndex: "TotalAmount",
      render: (value) => Math.round(value),
      sorter: (a, b) => a.TotalAmount - b.TotalAmount
    },
    {
      title: "Destination",
      dataIndex: "Destination",
      sorter: (a, b) => (a.Destination || "").localeCompare(b.Destination || "")
    },
    {
      title: "Dispatched Via",
      dataIndex: "Dispatched_Via",
      sorter: (a, b) => (a.Dispatched_Via || "").localeCompare(b.Dispatched_Via || "")
    },
    {
      title: "Status",
      dataIndex: "Status",
      filters: [
        { text: "Pending", value: "Pending" },
        { text: "Partial", value: "Partial" },
        { text: "Full", value: "Full" }
      ],
      onFilter: (value, record) => record.Status === value,
      sorter: (a, b) => (a.Status || "").localeCompare(b.Status || ""),
      render: (value) => (
          <span style={{
            color: value === "Full" ? "green" : value === "Partial" ? "#faad14" : "red"
          }}>
          {value}
        </span>
      )
    },
    {
      title: "Actions",
      render: (_, record) => (
          <>
            <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => handleEditInvoice(record)}
                disabled={record.Status === "Full"}
            >
              Edit
            </Button>
            <Popconfirm
                title="Delete this invoice?"
                onConfirm={() => handleDeleteInvoice(record.InvoiceID)}
                okText="Yes"
                cancelText="No"
                disabled={record.Status === "Full"}
            >
              <Button type="link" icon={<DeleteOutlined />} danger disabled={record.Status === "Full"}>
                Delete
              </Button>
            </Popconfirm>
            <Button
                type="link"
                onClick={() => handleViewInvoice(record)}
            >
              View
            </Button>
          </>
      )
    }
  ];

  return (
      <Card title="Purchase Invoices" extra={
          <Space>
                <Button type="primary" onClick={() => {
                  setVisible(true);
                  setEditingInvoice(null);
                  form.resetFields();
                }}>
                  Add Purchase Invoice
                </Button>
              <Button
                  type="default"
                  icon={<MergeOutlined />}
                  onClick={() => {
                      console.log('Navigating to mergepurchaseinvoice');  // ADD THIS
                      navigate('/mergepurchaseinvoice');
                  }}
              >
                  Merge PDFs
              </Button>


          </Space>
       }>
        {/* Filter Controls */}
        <Row gutter={8} style={{ marginBottom: 16 }}>
            <Col>
                <Select
                    mode="multiple"
                    showSearch
                    allowClear
                    placeholder="Filter by Invoice Number"
                    style={{ width: 200 }}
                    value={invoiceNumberFilter}
                    onChange={setInvoiceNumberFilter}
                    filterOption={(input, option) =>
                        option.children.toLowerCase().startsWith(input.toLowerCase())
                    }
                >
                    {Array.from(new Set(invoices.map(inv => inv.InvoiceNumber)))
                        .filter(Boolean)
                        .map(invNum => (
                            <Option value={invNum} key={invNum}>{invNum}</Option>
                        ))}
                </Select>
            </Col>
            <Col>
            <Select
                mode="multiple"
                showSearch
                allowClear
                placeholder="Filter by Supplier"
                style={{ width: 200 }}
                value={supplierFilter}
                onChange={setSupplierFilter}
                filterOption={(input, option) =>
                    option.children.toLowerCase().startsWith(input.toLowerCase())
                }
            >
              {suppliers.map(s => (
                  <Option value={s.SupplierID} key={s.SupplierID}>
                    {s.SupplierName}
                  </Option>
              ))}
            </Select>

          </Col>
          <Col>
            <Tooltip title="Type: >2025-01-01, <2025-01-01, >=2025-01-01, =2025-01-01">
              <Input
                  placeholder="Date (e.g. >2025-01-01)"
                  value={dateFilter}
                  onChange={e => setDateFilter(e.target.value)}
                  style={{ width: 170 }}
              />
            </Tooltip>
          </Col>
          <Col>
            <Select
                mode="multiple"
                showSearch
                allowClear
                placeholder="Filter by PO Number"
                style={{ width: 160 }}
                value={poNumberFilter}
                onChange={setPONumberFilter}
                filterOption={(input, option) =>
                    option.children.toLowerCase().startsWith(input.toLowerCase())
                }
            >
              {Array.from(new Set(invoices.map(inv => inv.PO_Number)))
                  .filter(Boolean)
                  .map(po => (
                      <Option value={po} key={po}>{po}</Option>
                  ))}
            </Select>

          </Col>
          <Col>
            <Select
                mode="multiple"
                allowClear
                placeholder="Filter by Status"
                style={{ width: 120 }}
                onChange={setStatusFilter}
                value={statusFilter}
            >
              <Option value="Pending">Pending</Option>
              <Option value="Partial">Partial</Option>
              <Option value="Full">Full</Option>
            </Select>

          </Col>
          <Col>
            <Button onClick={() => {
              setSupplierFilter([]);
              setDateFilter("");
              setPONumberFilter([]);
              setStatusFilter([]);
            }}>
              Reset
            </Button>

          </Col>
        </Row>

        <Table
            dataSource={filteredInvoices}
            columns={columns}
            rowKey="InvoiceID"
            pagination={{ pageSize: 10 }}
            loading={loading}
        />

        {/* Add/Edit Invoice Modal */}
        <Modal
            open={visible}
            onCancel={() => {
              setVisible(false);
              setEditingInvoice(null);
              form.resetFields();
            }}
            footer={null}
            title={editingInvoice ? "Edit Purchase Invoice" : "Add Purchase Invoice"}
            width={1600}
        >
          <Form
              form={form}
              //onValuesChange={onValuesChange}
              onFinish={onFinish}
              layout="vertical"
              initialValues={{ items: [{}] }}
          >
            <Row gutter={16}>
              <Col span={6}>
                  {/* Supplier */}
                  <Form.Item
                      name="SupplierName"
                      label={<span style={{ fontWeight: 'bold' }}>Supplier</span>}
                      rules={[{ required: true, message: "Supplier is required" }]}
                  >
                      {editingInvoice ? (
                          <Input
                              disabled={editingInvoice}
                              placeholder="Enter Supplier"
                              value={form.getFieldValue('SupplierName')}
                              onChange={e => form.setFieldsValue({ SupplierName: e.target.value })}
                          />
                      ) : (
                          <Input
                              placeholder="Enter Supplier"
                              value={form.getFieldValue('SupplierName')}
                              onChange={e => form.setFieldsValue({ SupplierName: e.target.value })}
                          />
                      )}
                  </Form.Item>

              </Col>
              <Col span={6}>
                  {/* Date */}
                  <Form.Item
                      name="Date"
                      label={<span style={{ fontWeight: 'bold' }}>Date</span>}
                      rules={[{ required: true, message: "Date is required" }]}
                  >
                      {editingInvoice ? (
                          <DatePicker
                              style={{ width: "100%" }}
                              disabled
                              value={form.getFieldValue("Date") ? moment(form.getFieldValue("Date")) : null}
                          />
                      ) : (
                          <DatePicker style={{ width: "100%" }} />
                      )}
                  </Form.Item>
              </Col>
              <Col span={6}>
                  {/* Invoice Number */}
                  <Form.Item
                      name="InvoiceNumber"
                      label={
                          <span style={{ fontWeight: "bold" }}>
            Invoice Number{" "}
                              {invoiceNumber ? (
                                  isDuplicate ? (
                                      <span style={{ color: "red" }}>Duplicate = Y</span>
                                  ) : (
                                      <span style={{ color: "green" }}>Duplicate = N</span>
                                  )
                              ) : null}
        </span>
                      }
                      rules={[{ required: true, message: "Please enter Invoice Number" }]}
                  >
                      <Input
                          disabled={!!editingInvoice}
                          placeholder="Enter Invoice Number (alphanumeric)"
                          value={invoiceNumber}
                          onChange={onInvoiceNumberChange}
                      />
                  </Form.Item>


              </Col>
              <Col span={6}>
                 <Form.Item
                    name="RefNoDate"
                    label={<span style={{ fontWeight: 'bold' }}>Ref No/Date</span>}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                  <Form.Item
                      label="Customer"
                      name="OtherReference"
                      rules={[{ required: false, message: "Please select a customer" }]}
                  >
                      {editingInvoice ? (
                          // Read-only display for editing mode
                          <Select
                              showSearch
                              optionFilterProp="children"
                              placeholder="Select a customer"
                              onChange={(value, option) => {
                                  // Set the selected customer label (Name - Location) into OtherReference field
                                  form.setFieldsValue({ OtherReference: option.children });
                              }}
                          >
                              {customers.map(cust => (
                                  <Select.Option key={cust.CustomerID} value={`${cust.CustomerName} - ${cust.Location}`}>
                                      {`${cust.CustomerName} - ${cust.Location}`}
                                  </Select.Option>
                              ))}
                          </Select>
                      ) : (
                          // Editable select for add mode
                          <Select
                              showSearch
                              optionFilterProp="children"
                              placeholder="Select a customer"
                              onChange={(value, option) => {
                                  // Set the selected customer label (Name - Location) into OtherReference field
                                  form.setFieldsValue({ OtherReference: option.children });
                              }}
                          >
                              {customers.map(cust => (
                                  <Select.Option key={cust.CustomerID} value={`${cust.CustomerName} - ${cust.Location}`}>
                                      {`${cust.CustomerName} - ${cust.Location}`}
                                  </Select.Option>
                              ))}
                          </Select>
                      )}
                  </Form.Item>
              </Col>
              <Col span={6}>
                  <Form.Item
                      name="PO_Number"
                      label={<span style={{ fontWeight: 'bold' }}>PO Number</span>}
                  >
                      <Input
                          //disabled={!!editingInvoice}
                      />
                  </Form.Item>
              </Col>
              <Col span={6}>
                  {/* PO Date */}
                  <Form.Item
                      name="PO_Date"
                      label={<span style={{ fontWeight: 'bold' }}>PO Date</span>}
                  >
                      {editingInvoice ? (
                          <DatePicker
                              style={{ width: "100%" }}
                              //disabled
                              value={form.getFieldValue("PO_Date") ? moment(form.getFieldValue("PO_Date")) : null}
                          />
                      ) : (
                          <DatePicker style={{ width: "100%" }} />
                      )}
                  </Form.Item>
              </Col>
            </Row>
              <Row gutter={16}>
              <Col span={6}>
                <Form.Item
                    name="Dispatched_Via"
                    label={<span style={{ fontWeight: 'bold' }}>Dispatched Via</span>}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col >
                <Form.Item
                    name="Destination"
                    label={<span style={{ fontWeight: 'bold' }}>Destination</span>}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col>
                  <Form.Item
                      label="Upload Invoice"
                  >
                      <Upload
                          name="invoiceFiles"
                          accept=".pdf,image/*"
                          listType="picture"
                          multiple
                          fileList={fileList}
                          beforeUpload={file => {
                              const isLt10M = file.size / 1024 / 1024 < 10;
                              if (!isLt10M) {
                                  message.error(`File ${file.name} is too large! Max 10MB.`);
                                  return false;
                              }
                              setFileList(prevList => [...prevList, file]);
                              return false; // Prevent automatic upload
                          }}
                          onRemove={file => {
                              setFileList(prevList => prevList.filter(item => item.uid !== file.uid));
                          }}
                          onPreview={file => {
                              if (file.url) window.open(file.url, "_blank");
                          }}
                      >
                          <Button icon={<UploadOutlined />}>Upload (PDF/Image)</Button>
                      </Upload>
                      {/* ✅ Progress Bar */}
                      {Object.keys(uploadProgress).length > 0 && (
                          <div style={{ marginTop: 12 }}>
                              <strong>Upload Progress:</strong>
                              {Object.entries(uploadProgress).map(([uid, percent]) => {
                                  const file = fileList.find(f => f.uid === uid);
                                  return (
                                      <div key={uid} style={{ marginTop: 8 }}>
                                          <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ width: 150, marginRight: 12 }}>
                {file?.name || 'File'}
              </span>
                                              <Progress
                                                  percent={Math.round(percent)}
                                                  size="small"
                                                  status={percent === 100 ? 'success' : 'active'}
                                                  strokeColor={{ '0%': '#108ee9', '100%': '#87d068' }}
                                              />
                                              <span style={{ marginLeft: 8, fontSize: 12 }}>
                {Math.round(percent)}%
              </span>
                                          </div>
                                      </div>
                                  );
                              })}
                          </div>
                      )}
                  </Form.Item>
                  {/* Display list of uploaded files below the upload field */}
                  {fileList.length > 0 && (
                      <div style={{ marginTop: 12 }}>
                          <strong>Uploaded Files:</strong>
                          <ul>
                              {fileList.map((file, idx) => (
                                  <li key={file.uid || idx}>
                                      {file.url ? (
                                          <a href={file.url} target="_blank" rel="noopener noreferrer">
                                              {file.name}
                                          </a>
                                      ) : (
                                          file.name
                                      )}
                                  </li>
                              ))}
                          </ul>
                      </div>
                  )}
              </Col>
                <Col>
                    <Radio.Group
                        value={taxType}
                        onChange={e => {
                            const newTaxType = e.target.value;
                            setTaxType(newTaxType);

                            // Reset SAC & Taxes for all items when taxType changes
                            const currentItems = form.getFieldValue("items") || [];
                            const resetItems = currentItems.map(item => ({
                                ...item,
                                SAC_Code: undefined,
                                CGST: 0,
                                SGST: 0,
                                IGST: 0,
                            }));
                            form.setFieldsValue({ items: resetItems });
                        }}
                        optionType="button"
                        buttonStyle="solid"
                    >
                        <Radio value="IGST">IGST</Radio>
                        <Radio value="CGST_SGST">CGST/SGST</Radio>
                    </Radio.Group>
                </Col>
            </Row>

            {/* Items List */}
            <Form.List name="items">
              {(fields, { add, remove }) => (
                  <>
                    <div style={{
                      display: 'flex',
                      fontWeight: 'bold',
                      marginBottom: 8,
                      gap: 8
                    }}>
                      <div style={{ flex: 2 }}>{requiredHeader("Item Name")}</div>
                      <div style={{ flex: 1 }}>{requiredHeader("Rate")}</div>
                      <div style={{ flex: 1 }}>{requiredHeader("Qty")}</div>
                      <div style={{ flex: 1 }}>{requiredHeader("UOM")}</div>
                      <div style={{ flex: 1 }}>{requiredHeader("SAC Code")}</div>
                      <div style={{ flex: 1, fontWeight: 'bold' }}>CGST%</div>
                      <div style={{ flex: 1, fontWeight: 'bold' }}>SGST%</div>
                      <div style={{ flex: 1, fontWeight: 'bold' }}>IGST%</div>
                      <div style={{ flex: 1, fontWeight: 'bold' }}>TaxAmount</div>
                      <div style={{ flex: 1, fontWeight: 'bold' }}>Total</div>
                      <div style={{ flex: 1, fontWeight: 'bold' }}>Remove</div>
                    </div>
                    {fields.map(({ key, name, ...restField }) => (
                        <div key={key} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                          <Form.Item
                              {...restField}
                              name={[name, "ItemName"]}
                              rules={[{ required: true, message: "Item Name is required" }]}
                              style={{ flex: 2, marginBottom: 0 }}
                              label={null}
                          >
                            <Input placeholder="Item Name" />
                          </Form.Item>
                            <Form.Item
                                {...restField}
                                name={[name, "Rate"]}
                                rules={[{ required: true, message: "Rate is required" }]}
                                style={{ flex: 1, marginBottom: 0 }}
                                label={null}
                            >
                                <InputNumber
                                    min={0}
                                    placeholder="Rate"
                                    style={{ width: "100%" }}
                                    onChange={(value) => onRateOrQuantityChange(name, 'Rate', value)}
                                />
                            </Form.Item>
                            <Form.Item
                                {...restField}
                                name={[name, "Quantity"]}
                                rules={[{ required: true, message: "Qty is required" }]}
                                style={{ flex: 1, marginBottom: 0 }}
                                label={null}
                            >
                                <InputNumber
                                    min={1}
                                    placeholder="Qty"
                                    style={{ width: "100%" }}
                                    onChange={(value) => onRateOrQuantityChange(name, 'Quantity', value)}
                                />
                            </Form.Item>

                            <Form.Item
                              {...restField}
                              name={[name, "UOM"]}
                              rules={[{ required: true, message: "UOM is required" }]}
                              style={{ flex: 1, marginBottom: 0 }}
                              label={null}
                          >
                            <Input placeholder="UOM" />
                          </Form.Item>
                            <Form.Item
                                {...restField}
                                name={[name, "SAC_Code"]}
                                rules={[{ required: true, message: "SAC Code is required" }]}
                                style={{ flex: 1, marginBottom: 0 }}
                                label={null}
                            >
                                <Select
                                    placeholder="SAC Code"
                                    showSearch
                                    optionFilterProp="children"
                                    onChange={(value) => {
                                        const selectedSac = sacCodes.find(sac => sac.SAC_Code === value);
                                        if (!selectedSac) return;

                                        const gstVal = selectedSac.GST_Value;
                                        let cgst = 0, sgst = 0, igst = 0;

                                        if (taxType === 'IGST') {
                                            igst = gstVal;
                                        } else if (taxType === 'CGST_SGST') {
                                            cgst = sgst = gstVal / 2;
                                        }

                                        const items = form.getFieldValue('items') || [];
                                        const currentItem = items[name] || {};

                                        const rate = Number(currentItem.Rate) || 0;
                                        const quantity = Number(currentItem.Quantity) || 0;
                                        const rateAmount = rate * quantity;

                                        // Calculate TaxAmount based on GST
                                        const taxAmount = (rateAmount * gstVal) / 100;

                                        // Calculate Total for this item
                                        const total = rateAmount + taxAmount;

                                        // Update the current item
                                        const updatedItem = {
                                            ...currentItem,
                                            SAC_Code: value,
                                            CGST: cgst,
                                            SGST: sgst,
                                            IGST: igst,
                                            TaxAmount: taxAmount,
                                            Total: total,
                                        };

                                        // Replace the item in list
                                        items[name] = updatedItem;

                                        // Recalculate total invoice amount
                                        const invoiceTotal = items.reduce((sum, item) => sum + (Number(item.Total) || 0), 0);

                                        // Set the updated items and invoice total
                                        form.setFieldsValue({ items, InvoiceTotal: invoiceTotal });
                                    }}


                                >
                                    {sacCodes.map(sac => (
                                        <Select.Option key={sac.SAC_Code} value={sac.SAC_Code}>
                                            {sac.SAC_Code}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>


                            {/* CGST % Field */}
                            <Form.Item shouldUpdate style={{ flex: 1, marginBottom: 0 }}>
                                {({ getFieldValue }) => {
                                    const itemIGST = getFieldValue(['items', name, 'IGST']) || 0;
                                    const taxTypeLocal = taxType; // Ensure taxType is accessible here, or pass via closure/context

                                    // Disable CGST if IGST is > 0 or taxType is IGST (to prevent editing CGST when IGST mode)
                                    const disableCGST =
                                        Number(itemIGST) > 0 || (taxTypeLocal === 'IGST');

                                    return (
                                        <Form.Item
                                            name={[name, 'CGST']}
                                            style={{ marginBottom: 0 }}
                                            noStyle
                                        >
                                            <InputNumber
                                                min={0}
                                                placeholder="CGST%"
                                                style={{ width: "100%" }}
                                                disabled={disableCGST}
                                            />
                                        </Form.Item>
                                    );
                                }}
                            </Form.Item>

                            {/* SGST % Field */}
                            <Form.Item shouldUpdate style={{ flex: 1, marginBottom: 0 }}>
                                {({ getFieldValue }) => {
                                    const itemIGST = getFieldValue(['items', name, 'IGST']) || 0;
                                    const taxTypeLocal = taxType;

                                    // Disable SGST if IGST is > 0 or taxType is IGST
                                    const disableSGST =
                                        Number(itemIGST) > 0 || (taxTypeLocal === 'IGST');

                                    return (
                                        <Form.Item
                                            name={[name, 'SGST']}
                                            style={{ marginBottom: 0 }}
                                            noStyle
                                        >
                                            <InputNumber
                                                min={0}
                                                placeholder="SGST%"
                                                style={{ width: "100%" }}
                                                disabled={disableSGST}
                                            />
                                        </Form.Item>
                                    );
                                }}
                            </Form.Item>

                            {/* IGST % Field */}
                            <Form.Item shouldUpdate style={{ flex: 1, marginBottom: 0 }}>
                                {({ getFieldValue }) => {
                                    const itemCGST = getFieldValue(['items', name, 'CGST']) || 0;
                                    const itemSGST = getFieldValue(['items', name, 'SGST']) || 0;
                                    const taxTypeLocal = taxType;

                                    // Disable IGST if CGST or SGST has value or taxType is CGST/SGST mode
                                    const disableIGST =
                                        (Number(itemCGST) > 0 || Number(itemSGST) > 0) || (taxTypeLocal === 'CGST_SGST');

                                    return (
                                        <Form.Item
                                            name={[name, 'IGST']}
                                            style={{ marginBottom: 0 }}
                                            noStyle
                                        >
                                            <InputNumber
                                                min={0}
                                                placeholder="IGST%"
                                                style={{ width: "100%" }}
                                                disabled={disableIGST}
                                            />
                                        </Form.Item>
                                    );
                                }}
                            </Form.Item>
                            {/* TaxAmount Field */}
                            <Form.Item
                                {...restField}
                                name={[name, "TaxAmount"]}
                                //rules={[{ required: true, message: "Tax Amount is required" }]}
                                style={{ flex: 1, marginBottom: 0 }}
                                label={null}
                            >
                                <InputNumber
                                    min={0}
                                    placeholder="Tax Amount"
                                    style={{ width: "100%" }}
                                    onChange={(value) => {
                                        const items = form.getFieldValue('items') || [];
                                        const currentItem = items[name] || {};

                                        const rate = Number(currentItem.Rate) || 0;
                                        const quantity = Number(currentItem.Quantity) || 0;
                                        const basicAmount = rate * quantity;

                                        // Update this item
                                        items[name] = {
                                            ...currentItem,
                                            TaxAmount: value,
                                            CGST: 0,
                                            SGST: 0,
                                            IGST: 0,
                                            Total: basicAmount + (value || 0),
                                            _userEditedTaxAmount: true,  // mark manual tax edit
                                        };

                                        // Calculate overall InvoiceTotal
                                        const invoiceTotal = items.reduce((sum, item) => sum + (Number(item.Total) || 0), 0);

                                        // Update form fields
                                        form.setFieldsValue({ items, InvoiceTotal: invoiceTotal });
                                    }}
                                />
                            </Form.Item>


                            {/* Total  Field */}
                            <Form.Item
                                {...restField}
                                name={[name, "Total"]}
                                style={{ flex: 1, marginBottom: 0 }}
                                label={null}
                            >
                                <InputNumber
                                    min={0}
                                    placeholder="Total"
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>

                            <Button
                              danger
                              onClick={() => remove(name)}
                              icon={<span style={{ fontWeight: 'bold' }}>−</span>}
                              style={{ flex: 1, minWidth: 32 }}
                              disabled={fields.length === 1}
                          />
                        </div>
                    ))}
                    <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<span style={{ fontWeight: 'bold' }}>+</span>}
                        style={{ marginTop: 8 }}
                    >
                      Add Item
                    </Button>
                  </>
              )}
            </Form.List>

              <Form.Item shouldUpdate>
                  {() => {
                      const items = form.getFieldValue('items') || [];
                      const invoiceTotal = items.reduce((acc, item) => {
                          return acc + Number(item?.Total || 0);
                      }, 0);

                      return (
                          <div style={{ textAlign: 'right', fontWeight: 'bold', marginTop: 16 }}>
                              Invoice Total: {invoiceTotal.toFixed(2)}
                          </div>
                      );
                  }}
              </Form.Item>

              <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
                  <Button
                      onClick={() => setVisible(false)}
                      style={{ marginRight: 8 }}
                      size="large"
                  >
                      Cancel
                  </Button>
                  <Button
                      type="primary"
                      htmlType="submit"
                      loading={uploading}
                      disabled={uploading || isDuplicate}
                      size="large"
                      style={{
                          opacity: isDuplicate ? 0.6 : 1,
                          cursor: isDuplicate ? 'not-allowed' : 'pointer'
                      }}
                  >
                      {uploading
                          ? `Creating Invoice... ${uploadProgress.overall || 0}%`
                          : isDuplicate
                              ? '⚠️ Duplicate Invoice Number - Fix First'
                              : `Add Invoice (${fileList.length} files)`
                      }
                  </Button>

                  {uploading && (
                      <div style={{
                          marginTop: 8,
                          padding: '8px',
                          background: '#f0f9ff',
                          borderRadius: 4,
                          fontSize: 12,
                          textAlign: 'left'  
                      }}>
                          ⏳ Uploading {fileList.filter(f => f.originFileObj).length} file(s)...
                      </div>
                  )}
              </Form.Item>


          </Form>
        </Modal>

        {/* View Invoice Modal */}
        <Modal
            open={!!viewInvoice}
            onCancel={() => {
              setViewInvoice(null);
              setViewItems([]);
            }}
            footer={null}
            title={viewInvoice ? `Invoice #${viewInvoice.InvoiceNumber}` : "Invoice Details"}
            width={900}
        >
          {viewInvoice && (
              <div>
                {/* Section 1: Invoice Details */}
                <h3>Invoice Details</h3>
                <Row gutter={24}>
                  <Col span={12}>
                    <p><b>Invoice Number:</b> {viewInvoice.InvoiceNumber}</p>
                    <p><b>Date:</b> {viewInvoice.Date}</p>
                    <p><b>Supplier:</b> {getSupplierName(viewInvoice.SupplierID)}</p>
                    <p><b>Ref No/Date:</b> {viewInvoice.RefNoDate}</p>
                    <p><b>Customer:</b> {viewInvoice.OtherReference}</p>
                  </Col>
                  <Col span={12}>
                    <p><b>PO Number:</b> {viewInvoice.PO_Number}</p>
                    <p><b>PO Date:</b> {viewInvoice.PO_Date}</p>
                    <p><b>Dispatched Via:</b> {viewInvoice.Dispatched_Via}</p>
                    <p><b>Destination:</b> {viewInvoice.Destination}</p>
                      <div style={{ margin: "8px 0" }}>
                          <b>Uploaded Invoices: </b>
                          {viewInvoice?.InvoiceFile ? (
                              <>
                                  {(() => {
                                      try {
                                          // ✅ Parse JSON array from database
                                          const files = JSON.parse(viewInvoice.InvoiceFile || '[]');

                                          if (files.length === 0) {
                                              return <span style={{ color: '#999' }}>No files attached</span>;
                                          }

                                          return (
                                              <div>
                                                  {files.map((filePath, index) => (
                                                      <div key={index} style={{ marginBottom: 8, padding: '8px', border: '1px solid #e8e8e8', borderRadius: 4 }}>
                  <span style={{ marginRight: 12 }}>
                    📄 {filePath.split('/').pop()}
                      <small style={{ color: '#666', marginLeft: 8 }}>
                      ({index + 1} of {files.length})
                    </small>
                  </span>
                                                          <a
                                                              href={filePath.startsWith('http') ? filePath : `${filePath}`} // Adjust BASE_URL as needed
                                                              target="_blank"
                                                              rel="noopener noreferrer"
                                                              style={{ marginLeft: 8 }}
                                                          >
                                                              <DownloadOutlined /> View/Download
                                                          </a>
                                                      </div>
                                                  ))}
                                              </div>
                                          );
                                      } catch (error) {
                                          // Fallback for old single file format
                                          console.warn('Invalid JSON in InvoiceFile:', error);
                                          return (
                                              <>
                                                  <span>{viewInvoice.InvoiceFile.split('/').pop()}</span>
                                                  <a
                                                      href={viewInvoice.InvoiceFile}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                      style={{ marginLeft: 8 }}
                                                  >
                                                      <DownloadOutlined /> View/Download
                                                  </a>
                                              </>
                                          );
                                      }
                                  })()}
                              </>
                          ) : (
                              <span style={{ color: '#999' }}>No files attached</span>
                          )}
                      </div>


                  </Col>
                </Row>
                <hr />

                {/* Section 2: Amounts */}
                <h3>Amounts</h3>
                <Row gutter={24}>
                  <Col span={12}>
                    <p><b>Total Amount:</b> {Math.round(viewInvoice.TotalAmount)}</p>
                    <p><b>Status:</b> {viewInvoice.Status}</p>
                  </Col>
                </Row>
                <hr />

                {/* Section 3: Items */}
                <h3>Invoice Items</h3>
                <Table
                    dataSource={viewItems}
                    columns={[
                      { title: "Item Name", dataIndex: "ItemName" },
                      { title: "UOM", dataIndex: "UOM" },
                      { title: "SAC Code", dataIndex: "SAC_Code" },
                      { title: "Rate", dataIndex: "Rate" },
                      { title: "Quantity", dataIndex: "Quantity" },
                      { title: "Rate Amount", dataIndex: "RateAmount" },
                      { title: "CGST (%)", dataIndex: "CGST" },
                      { title: "SGST (%)", dataIndex: "SGST" },
                      { title: "IGST (%)", dataIndex: "IGST" },
                      { title: "Tax Amount", dataIndex: "TaxAmount" },
                      {
                        title: "Total",
                        dataIndex: "Total",
                        render: (value, record) =>
                            value !== undefined
                                ? value
                                : (Number(record.RateAmount) || 0) + (Number(record.TaxAmount) || 0)
                      }
                    ]}
                    rowKey="ItemID"
                    pagination={false}
                    size="small"
                />
              </div>
          )}
        </Modal>
      </Card>
  );
}
